import { generateResourceReducer } from '../generators/resource.reducer';
import * as types from './project.types';
import * as constants from './project.constants';

export const projectReducer = generateResourceReducer<types.IProject>({
  STORE: constants.STORE_PROJECT,
  CLEAR: constants.CLEAR_PROJECT,
});
